export const stringToDatetime = (str) => {
  if (str && str != '-') {
    return new Date(str).toLocaleString()
  }
  return '-'
}